import { Button, FormControl, FormErrorMessage, FormLabel, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text } from "@chakra-ui/react";


interface IOrderEntregavel  {
 show: boolean;
 showModal: (show: boolean) => void;
 error: boolean;
 textColor: string;
 brandStars: string;
 nomeRef : any;
 loading : boolean;
 save : () => void;
}

const OrderEntregavel = ({show, showModal, brandStars, error, nomeRef, textColor, loading, save}:IOrderEntregavel) => {


    return (
        <Modal
        onClose={() => {
          showModal(false);
        }}
        size={"2xl"}
        isOpen={show}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
        Novo Cadastro de Entregável
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl isInvalid={error}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Nome<Text color={brandStars}>*</Text>
              </FormLabel>
              <Input
                ref={nomeRef}
                isRequired={true}
                variant="auth"
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Preencha o nome do Entregável"
                onChange={(e) => (nomeRef.current = e.target.value)}
                mb="24px"
                fontWeight="500"
                isInvalid={error}
                size="lg"
              />
              {error && (
                <FormErrorMessage>
                  Preencha Corretamente o Campo.
                </FormErrorMessage>
              )}
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button
              onClick={() => {
                showModal(false);
              }}
              variant="outline"
              marginRight={4}
            >
              Fechar
            </Button>
            <Button
              onClick={() => {
                save();
              }}
              colorScheme="brand"
              isLoading={loading}
            >
              Salvar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    )

}

export default OrderEntregavel;